import { render, staticRenderFns } from "./c_noticebar.vue?vue&type=template&id=0edeb0c9&scoped=true"
import script from "./c_noticebar.vue?vue&type=script&lang=js"
export * from "./c_noticebar.vue?vue&type=script&lang=js"
import style0 from "./c_noticebar.vue?vue&type=style&index=0&id=0edeb0c9&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0edeb0c9",
  null
  
)

export default component.exports